import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../Constants/queryKeys';
import { GetDepartmentsWithSupervisors } from '../helper/apiHelper';

export const useDepartmentsWithSupervisors = () => {
  return useQuery({
    queryKey: [...QUERY_KEYS.DEPARTMENTS_WITH_SUPERVISORS],
    queryFn: GetDepartmentsWithSupervisors,
  });
};
